<script lang="ts">
  import Button from '$shared/atoms/Button/Button.svelte';
import { ButtonStyle } from '$shared/constants/ButtonStyle';
import { ButtonSize } from '$shared/constants/ButtonSize';
  import Title from '$shared/atoms/Title/Title.svelte';
  import Label from '$provider/constants/Label';
  import EmptyMagic from '$shared/images/emptyPage/magic.svg';

  const DefaultLabel = 'There are no changes from this source to merge with this profile';

  interface Props {
    label: string | undefined;
    onclick?: () => void;
  }

  let { label, onclick }: Props = $props();
</script>

<div class="comp-empty-merge-list">
  <div class="container">
    <div class="icon"><img src={EmptyMagic} alt="No match icon" /></div>
    <div class="title"><Title type="h1">Nothing to Merge</Title></div>
    <div class="label">{label || DefaultLabel}</div>

    <div class="close-action">
      <Button style={ButtonStyle.Primary} size={ButtonSize.Medium} {onclick}>{Label.Close}</Button>
    </div>
  </div>
</div>

<style>
  .comp-empty-merge-list {
    background-color: var(--grey-bg);
    width: 100%;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .icon,
  .title {
    margin-bottom: 16px;
  }
  .label {
    color: var(--grey-dark);
    margin-bottom: 32px;
  }
</style>
